/* eslint-disable camelcase */
import React from 'react';
import {
  CopyIcon,
  CountryCropMapIcon,
  FleetTelematicsIcon,
  IntegrationsIcon,
  CropManagementIcon,
  FarmOperationsIcon,
  ApiCustomDashboardIcon,
  SystemConfigurationIcon,
  ProductServicesIcon,
} from 'components/cwo-icons';

const cwoModuleConfig = {
  telematics: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <FleetTelematicsIcon />
      </span>
    ),
  },
  integrations: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <IntegrationsIcon />
      </span>
    ),
  },
  other: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <CopyIcon />
      </span>
    ),
  },
  crop_management: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <CropManagementIcon />
      </span>
    ),
  },
  farm_operations: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <FarmOperationsIcon />
      </span>
    ),
  },
  api: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <ApiCustomDashboardIcon />
      </span>
    ),
  },
  system_configuration: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <SystemConfigurationIcon />
      </span>
    ),
  },
  p_plus_services: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <ProductServicesIcon />
      </span>
    ),
  },
  crop_map: {
    icon: (
      <span className="tickets-index-page__cwo-module-icon">
        <CountryCropMapIcon />
      </span>
    ),
  },
};
export default cwoModuleConfig;
